<template>
    <section class="content">

    <header id="header">
        <div class="row" style="margin-left: 10px">
        <div id="logo-top">
            
        </div>
            <nav id="nav">
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><a href="#one">Sobre</a></li>
                <li><a href="#three">Fale Conosco</a></li>
                <li><a href="dashboard.html" class="button special">Área do Logista</a></li>
            </ul>
        </nav>
        </div>
        
    </header>
    </section>
</template>

<script>

export default {
  name: 'home',
  data () {
    return {
      
    }
  },
  
}
</script>

<style>
/* Header */

	body.landing #header {
		left: 0;
		position: fixed;
		top: 0;
	}

		body.landing #header nav a {
			color: rgba(255, 255, 255, 0.5);
		}

	#header {
		background-color: rgba(56,59,67,0.5);
		color: #ffffff;
		cursor: default;
		font-size: 1.1em;
		height: 5em;
		line-height: 6em;
		width: 100%;
		z-index: 10000;
		transition-duration: 1s;
		-moz-transition-duration:1s;
		-webkit-transition-duration:1s;
		-o-transition-duration:1s;
		-webkit-transition: all 0.5s ease 0s;
		-moz-transition:All 0.1824s ease-in-out;
		transition: all 0.6s ease 0.5s;
		-o-transition: all 0.6s ease 2s;
	}

		#header h1 {
			color: #ffffff;
			height: inherit;
			left: 3em;
			line-height: inherit;
			margin: 0;
			padding: 0;
		}

			#header h1 a {
				font-size: 1.25em;
			}

		#header nav {
			height: inherit;
			line-height: inherit;
			position: absolute;
			right: 3em;
			vertical-align: middle;
		}

			#header nav > ul {
				list-style: none;
				margin: 0;
				padding-left: 0;
			}

				#header nav > ul > li {
					border-radius: 4px;
					display: inline-block;
					margin-left: 2em;
					padding-left: 0;
				}

					#header nav > ul > li a {
						-moz-transition: color 0.2s ease-in-out;
						-webkit-transition: color 0.2s ease-in-out;
						-o-transition: color 0.2s ease-in-out;
						-ms-transition: color 0.2s ease-in-out;
						transition: color 0.2s ease-in-out;
						color: #cdced0;
						display: inline-block;
						text-decoration: none;
					}

						#header nav > ul > li a:active, #header nav > ul > li a:hover {
							color: #ffffff;
						}

					#header nav > ul > li:first-child {
						margin-left: 0;
					}

					#header nav > ul > li .button {
						background-color: #fff;
						color: #444 !important;
						height: 2.25em;
						line-height: 2.25em;
						margin-bottom: 0;
						padding: 0 1em;
						position: relative;
						top: -0.075em;
						vertical-align: middle;
					}

		#header .container {
			position: relative;
		}

			#header .container h1 {
				left: 0;
			}

			#header .container nav {
				right: 0;
			}

</style>



// WEBPACK FOOTER //
// Home.vue?58f3c0ae